var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"header-logo",attrs:{"src":_vm.bgSrc,"alt":""},on:{"click":_vm.goHome}}),_c('Menu',{attrs:{"isWhite":_vm.isWhite}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }